// extracted by mini-css-extract-plugin
module.exports = {"skipLink":"SkipLink_skipLink__2qjWR"};